import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';

import { usePageVariant } from '../PageContext';
import { StyledContainer, StyledContent, StyledGraphics, StyledPageContent } from './Content.styles';

type Props = {
	isDecorative?: boolean;
	children?: ReactNode;
	tw?: string;
} & ComponentPropsWithoutRef<'div'>;

const Content: FC<Props> = ({ children, isDecorative = false, tw, ...props }) => {
	const pageVariant = usePageVariant();

	if (isDecorative) {
		return (
			<StyledContainer {...props} tw={tw}>
				<StyledContent>{children}</StyledContent>
				<StyledGraphics />
			</StyledContainer>
		);
	}

	return (
		<StyledPageContent $pageVariant={pageVariant} tw={tw} {...props}>
			{children}
		</StyledPageContent>
	);
};

export default Content;
